import { Auth } from 'aws-amplify';
import NotificationAPIClient from 'notificationapi-js-client-sdk';
import 'notificationapi-js-client-sdk/dist/styles.css';
import { PopupPosition } from 'notificationapi-js-client-sdk/lib/interfaces';
import React, { memo, useEffect } from 'react';
import axiosConfig from '../utils/axiosConfig';
import { readWebsiteVariable } from '../utils/readWebsiteVariable';
import { User } from '../interfaces/api/Auth';

export interface HashedUserId {
  notificationAPIHashedUserId: string;
}
const NotificationAPIComponent = memo(() => {
  const createNotificationAPIComponent = (user: User): void => {
    axiosConfig(
      'get',
      '/hashedUserId',
      { userId: user.username },
      (response) => {
        const res = response as Record<'data', HashedUserId>;
        const notificationapi = new NotificationAPIClient({
          clientId: readWebsiteVariable('REACT_APP_notificationAPI_clientId'),
          userId: user.username,
          userIdHash: res.data.notificationAPIHashedUserId
        });
        notificationapi.identify({
          email: user.attributes.email
        });
        notificationapi.showInApp({
          root: 'notificationApiRoot',
          popupPosition: PopupPosition.BottomLeft
        });
      }
    );
  };
  useEffect(() => {
    Auth.currentUserInfo().then((user) => {
      createNotificationAPIComponent(user);
    });
  });

  return <div id="notificationApiRoot"></div>;
});
export default NotificationAPIComponent;
